import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class LiderazgoPesvService {
  private apiUrl = `${environment.apiUrl}/api/liderazgo_pesv`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<any[]> {
    return this.http.get<any>(this.apiUrl, { withCredentials: true }).pipe(
      map((res) => (Array.isArray(res) ? res : (res?.data ?? []))),
    );
  }

  getById(id: number | string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}`, { withCredentials: true }).pipe(
      map((res) => res?.data ?? res),
    );
  }

  getByVersion(version: string): Observable<any> {
    const versionNormalizada = String(version || "").trim().toLowerCase();
    return this.getAll().pipe(
      map((items: any[]) =>
        (items || []).find(
          (item: any) => String(item?.version || "").trim().toLowerCase() === versionNormalizada,
        ) || null,
      ),
    );
  }

  create(data: any): Observable<any> {
    return this.http.post<any>(this.apiUrl, data, { withCredentials: true }).pipe(
      map((res) => res?.data ?? res),
    );
  }

  update(id: number | string, data: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}`, data, { withCredentials: true }).pipe(
      map((res) => res?.data ?? res),
    );
  }

  inactivar(id: number | string): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true }).pipe(
      map((res) => res?.data ?? res),
    );
  }

  activar(id: number | string): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true }).pipe(
      map((res) => res?.data ?? res),
    );
  }

  remove(id: number | string): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true }).pipe(
      map((res) => res?.data ?? res),
    );
  }

  activate(id: number | string): Observable<any> {
    return this.http.patch<any>(`${this.apiUrl}/${id}/activate`, {}, { withCredentials: true }).pipe(
      map((res) => res?.data ?? res),
    );
  }

  getConsecutivo(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/consecutivo`, { withCredentials: true }).pipe(
      map((res) => {
        const data = res?.data ?? res;

        if (data && typeof data === "object") {
          return data?.consecutivo ?? data?.value ?? data?.numero ?? data?.id ?? null;
        }

        return data ?? null;
      }),
    );
  }

}
